import http from '@/http/aisea/axios'
const resource = "/enterprises";

export default {

  // 法人Adminアカウントパスワード変更開始
  get(enterpriseLoginKey, payload) {
    return http.get(`${resource}/${enterpriseLoginKey}/admins/accounts/password/certificates`, {
          params: payload
        });
  },
  
  // 法人Adminアカウントパスワード変更
  update(enterpriseLoginKey, payload) {
    return http.put(`${resource}/${enterpriseLoginKey}/admins/accounts/password/certificates`, payload);
  },

};
